import Vue from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/ar-sa';
import 'core-js';
import App from './App.vue';
import RichText from './components/prismic/RichText';
import RichImage from './components/prismic/RichImage';
import createRouter from './router';
import createStore from './store';
import config from './config';
import initI18n from './helpers/i18n.ts';

import './scss/style.scss';

Vue.component('RichText', RichText);
Vue.component('RichImage', RichImage);

const createApp = locale => {
  const router = createRouter();
  const store = createStore();

  const app = new Vue({
    router,
    store,
    i18n: initI18n(config, locale, newLocale => {
      dayjs.locale(newLocale.toLowerCase());
    }),
    render: h => h(App)
  });

  return { app, router, store };
};

export default createApp;

const mountApp = () => {
  const { app, router, store } = createApp();

  if (window.__INITIAL_STATE__) {
    // We initialize the store state with the data injected from the server
    store.replaceState(window.__INITIAL_STATE__);
  }

  router.onReady(() => {
    app.$mount('#app');
  });
};

if (typeof window !== 'undefined') {
  // This is for Cypress to defer loading so that it can overwrite some stuff
  // eslint-disable-next-line no-underscore-dangle
  if (window._cypressDeferLoad) {
    window.deferredLoad = mountApp;
  } else {
    mountApp();
  }
}
